import { makeSingleItemPicker } from '../../MatchSelect'
import { fetchVodAsset, fetchVodAssets } from '../../../services/vodApi'

// Single-content pickers for carousel pins. Unlike the multi-select filter
// adapters in carouselLookups.tsx, a pin references exactly one item, and the
// stored value is that item's raw id. The picker shell and the match picker
// live in components/MatchSelect.tsx so they can be reused outside the
// carousel editor; only the VOD picker is pin-specific enough to stay here.

const vodLabel = (asset: any): string => {
  const title = asset?.tc_title || asset?.tc_vod_asset_id || ''
  const type = asset?.vod_type_display_name
  return type ? `${title} — ${type}` : title
}

export const VodPinSelect = makeSingleItemPicker(
  async (input, visibleOnSite) => {
    const resp = await fetchVodAssets({
      search: input,
      limit: 25,
      visible_on_site: visibleOnSite,
    })
    return (resp?.assets || []).map((a: any) => ({
      value: a.tc_vod_asset_id,
      label: vodLabel(a),
    }))
  },
  async (id) => vodLabel(await fetchVodAsset(id)),
  'pin-vod',
  'Search VOD…',
  'VOD assets',
)
